import React, { useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { SmartChargeSettingsFormModel } from 'src/Libs/smart-charge/models'
import { fromSmartChargeModelToFormModel } from 'src/Libs/smart-charge/transformers'
import { DefaultSectionProps } from 'src/Libs/smart-charge/types'
import WeatherForecastFormData from 'src/Libs/smart-charge/components/weather-forecast/WeatherForecastFormData'
import { makeStyles } from 'tss-react/mui'
import FormikWithExitHandler from 'src/Libs/form/components/FormikWithExitHandler'
import { useAppRatingContext } from 'src/Libs/app-rating/hooks'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'
import { PowermeterHardwareModel } from 'src/Libs/power-meters/models/power-meter.model'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props extends DefaultSectionProps {
  powermeterHardwares: PowermeterHardwareModel[]
  hasWritingRights?: boolean
}

const WeatherForecastSection: React.FC<Props> = ({ model, powermeterHardwares, onChange, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const [formValues, setFormValues] = useState(model ? fromSmartChargeModelToFormModel(model) : null)
  const { triggerAppRating } = useAppRatingContext()

  const handleSubmit = async (values: SmartChargeSettingsFormModel): Promise<void> => {
    try {
      await onChange(values)
      triggerAppRating()
    } catch (error) {
      /* revert changes */
      if (formValues) setFormValues({ ...formValues })
    }
  }

  if (!formValues) {
    return (
      <AccordionItem title={t('systemSettings.smartFunctions.smartCharge.weatherForecast.sectionTitle')}>
        <SystemSettingsBlankView />
      </AccordionItem>
    )
  }

  return (
    <AccordionItem
      title={t('systemSettings.smartFunctions.smartCharge.weatherForecast.sectionTitle')}
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
    >
      <FormikWithExitHandler formKey="weather-forecast-form" initialValues={formValues} onSubmit={handleSubmit}>
        <Box>
          <SettingsFormContainer model={formValues}>
            <WeatherForecastFormData hasWritingRights={hasWritingRights} powermeterHardwares={powermeterHardwares} />
          </SettingsFormContainer>
        </Box>
      </FormikWithExitHandler>
    </AccordionItem>
  )
}

export default WeatherForecastSection
